import { IconBolt, IconPhoto, IconSnowflake } from "@tabler/icons-react";
import type { ComponentType } from "react";

export interface Generator {
  /** URL segment under `/gallery` and `/generate`. */
  key: string;
  label: string;
  icon: ComponentType<{ size?: number }>;
  galleryDescription: string;
  generateDescription: string;
}

/**
 * The one list of generators the admin panel knows about. Navigation menus, the home page cards,
 * the Gallery/Generate tab switcher and the "not found" fallbacks all derive from it, so adding a
 * generator is one entry here plus its two pages and routes.
 */
export const GENERATORS: readonly Generator[] = [
  {
    key: "pillows",
    label: "Pillows",
    icon: IconPhoto,
    galleryDescription: "Browse generated pillow results.",
    generateDescription: "Start a pillow generation flow.",
  },
  {
    key: "ornaments",
    label: "Ornaments",
    icon: IconSnowflake,
    galleryDescription: "Browse generated photo ornaments.",
    generateDescription: "Put a photo inside a glass Christmas ball.",
  },
  {
    key: "serverless",
    label: "Serverless",
    icon: IconBolt,
    galleryDescription: "Open serverless gallery jobs.",
    generateDescription: "Run the serverless generator.",
  },
];

export const galleryPath = (g: Generator) => `/gallery/${g.key}`;
export const generatePath = (g: Generator) => `/generate/${g.key}`;
